// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"formatDropdown_fullWidth__HWBxT"};